import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Typography } from "@mui/material";
import { type FC, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";

export const StaffSatisfactionHeader: FC = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { chosenDepartment } = useHospitalData();

	const handleBack = useCallback(() => {
		const qs = searchParams.toString();
		navigate(`/${chosenDepartment.department_id}/management-center${qs ? `?${qs}` : ""}`);
	}, [searchParams, navigate, chosenDepartment.department_id]);

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				width: "100%",
				mb: 2,
			}}
		>
			<IconButton onClick={handleBack} aria-label="Back to Management Center">
				<ArrowBackIcon />
			</IconButton>
			<Typography
				variant="h6"
				sx={{
					fontWeight: 600,
				}}
			>
				{"Staff Satisfaction"}
			</Typography>
		</Box>
	);
};
